import { combineReducers } from 'redux';

import orderConditions from './order-conditions';

const screens = (state = {modelSets: false, setCard: false, order: false, categoryData: false, loading: true }, action) => {
  switch (action.type) {
    case 'SET_SCREEN':
      return { ...state, [action.name]: action.val};
    default:
      return state;
  }
};

const screensData = (state = { order: {typeMA: 'machine', typeNE: 'new'} }, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const mainScreenPage = (state = 'catalog', action) => {
  switch (action.type) {
    case 'SET_MAIN_SCREEN_PAGE':
      return action.p;
    default:
      return state;
  }
};

const category = (state = '', action) => {
  switch (action.type) {
    case 'SET_CATEGORY':
      return action.p;
    default:
      return state;
  }
};

const model = (state = '', action) => {
  switch (action.type) {
    case 'SET_MODEL':
      return action.p;
    default:
      return state;
  }
};

const set = (state = '', action) => {
  switch (action.type) {
    case 'SET_SET':
      return action.p;
    default:
      return state;
  }
};

const categoryMenuItemPos = (state = { right: 0, top: 0 }, action) => {
  switch (action.type) {
    case 'SET_CATEGORY_MENU_ITEM_POS':
      return { ...state, ...action.payload }
    default:
      return state;
  }
};

const categoryMenuItemActiveKey = (state = '', action) => {
  switch (action.type) {
    case 'SET_CATEGORY_MENU_ITEM_ACTIVE_KEY':
      return action.payload;
    case 'RESET_CATEGORY_MENU_ITEM_ACTIVE_KEY':
        return '';
    default:
      return state;
  }
};

const loading = (state = {category: false, models: false, sets: false, accessories: false, pictures: false, orders: false }, action) => {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, ...action.p };
    default:
      return state;
  }
};

export default combineReducers ({
  loading,
  screens,
  screensData,
  mainScreenPage,
  category,
  model,
  set,
  categoryMenuItemPos,
  categoryMenuItemActiveKey,
  orderConditions
});



// WEBPACK FOOTER //
// ./src/store/reducers/ui.js